import React from 'react';
import '../App.css'

const Hero = () => {
  return (
      <div className="overlay" id="home">
        <section className="intro"> 
          <div className="content">
            <h1>The finest from around you</h1>
            <h4>10 golden years of serving your savour</h4>
          </div>
        </section>
      </div>  
  );
}

export default Hero;
